import { PublicKey } from "@solana/web3.js";

export const MALICIOUS_RECIPIENT_ERROR =
  "Recipient address flagged as malicious";

type AddressRiskResponse = {
  malicious?: boolean;
};

export async function fetchAddressRisk(
  address: string,
  riskApiBaseUrl: string,
  network = "solana"
): Promise<AddressRiskResponse> {
  const trimmed = address.trim();
  const response = await fetch(
    `${riskApiBaseUrl}/address-risk?address=${encodeURIComponent(trimmed)}&network=${encodeURIComponent(network)}`,
    { method: "GET" }
  );

  if (!response.ok) {
    throw new Error("Address risk check failed");
  }

  return response.json() as Promise<AddressRiskResponse>;
}

export async function assertWithdrawRecipientAllowed(
  address: string,
  riskApiBaseUrl: string,
  network = "solana"
): Promise<void> {
  const trimmed = (address ?? "").trim();
  if (!trimmed) {
    throw new Error("Recipient address is required");
  }

  try {
    new PublicKey(trimmed);
  } catch {
    throw new Error("Invalid recipient address");
  }

  const data = await fetchAddressRisk(trimmed, riskApiBaseUrl, network);
  if (data?.malicious === true) {
    throw new Error(MALICIOUS_RECIPIENT_ERROR);
  }
}
